var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseRemoteService } from "../core/BaseRemoteService";
import { paramsToSearchString } from "../../utils/urlHelper";
export class CasesService extends BaseRemoteService {
    getAll(params = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.apiRoot}/cases/${paramsToSearchString(params)}`;
            return yield this.getRequest(url);
        });
    }
    get(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.apiRoot}/cases/${id}`;
            return yield this.getRequest(url);
        });
    }
    post(model) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.apiRoot}/cases`;
            return yield this.postRequest(url, model);
        });
    }
    patch(id, patchDocument) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.apiRoot}/cases/${id}`;
            return yield this.patchRequest(url, patchDocument);
        });
    }
    downloadExport(caseId) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.apiRoot}/cases/${caseId}/export`;
            return yield this.getRequestBlob(url);
        });
    }
    getAnalyticsDashboards() {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.apiRoot}/cases/caseanalytics`;
            const res = yield this.getRequest(url);
            return res.map(x => ({
                id: x,
                name: x,
            }));
        });
    }
    getAnalytics(params) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const dashboardName = (_a = params.type) !== null && _a !== void 0 ? _a : "Default";
            const url = `${this.apiRoot}/cases/caseanalytics/${dashboardName}`;
            return yield this.getRequest(url);
        });
    }
    getTeamAnalytics() {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.apiRoot}/cases/teamanalytics`;
            return yield this.getRequest(url);
        });
    }
}
